<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				操作其它出库单
			</div>
			<button class="jxyd-button jxyd-primary" title="审核" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				审核
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-print" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr colspan="4">
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>

					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.commoditySelected = data;}" :selectedCommodity="commoditySelected"
							:type='"2"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="commoditySelected"
							@submitSelected='data=>{this.commoditySelected = data;}' @onInputVal='onInputVal'
							:type='"2"'></SelectCommodityByCodeModal>
					</div>
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.outStoreDetailList"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已审核</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import DocumentFile from '@/components/DocumentFile'
	import SelectCommodityByCodeModal from '@/components/SelectCommodityByCodeModal'
	import printMixin from '@/mixins/printMixin'

	export default {
		name: 'outstorelistfunc',
		mixins: [printMixin],
		components: {
			SelectCommodityModal,
			DocumentFile,
			SelectCommodityByCodeModal
		},
		computed: {
			commoditySelected: {
				get() {
					let data = [];
					this.documentItem.outStoreDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {
							let dataItem = {};
							dataItem.commodity = item.commodity;
							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;
				},
				set(newValue) {
					this.documentItem.outStoreDetailList = [];
					newValue.forEach(item => {
						item.data.forEach(item2 => {
							this.documentItem.outStoreDetailList.push({
								commodityId: item.commodity.id,
								name: item.commodity.name,
								unit: item2.unit,
								format: item2.priceType,
								quantity: item2.quantity,
								batchCode: this.getLatestBatchCode(item, item2),
								price: item2.retailPrice,
								discount: 100,
								priceAfterDiscount: item2.retailPrice,
								amount: formatNum(item2.quantity * item2
									.retailPrice),
								note: '',
								creator: parseInt(localStorage.getItem("userId")),
								commodity: item.commodity,
								commodityId: item.commodity.id
							})
						});
					});
				}
			}
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					outStoreDetailList: [],
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					checkState: 1,
					fileList: []
				},
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.outStoreDetailList.splice(params.index,
											1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 350,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '计量单位',
						key: 'unit',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.documentItem.outStoreDetailList[params.index].unit =
												event;
											// 不允许负库存时，检查数量是否超过库存
											if (!params.row.commodity.negativeStock) {
												const maxStock = this.getSelectedCommodityTypeMaxStock(
													params.index);
												if (this.documentItem.outStoreDetailList[params.index]
													.quantity > maxStock) {
													this.documentItem.outStoreDetailList[params.index]
														.quantity = maxStock;
												}
											}
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 200,
					},
					{
						title: '批次号',
						key: 'batchCode',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										disabled: !params.row.commodity.enableBatch,
										multiple: true,
										transfer: true,
										value: params.row.batchCode
									},
									on: {
										input: (event) => {}
									},
								},
								this.formatBatchCodeSelectData(params.index, params.row.unit).map(function(
									type) {
									return h('Option', {
										props: {
											value: type.value,
											key: type.text
										}
									}, type.text);
								})
							)];
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 200,
						render: (h, params) => {
							const allowNegativeStock = params.row.commodity.negativeStock;
							// 允许负库存时不调用 getSelectedCommodityTypeMaxStock
							const maxValue = allowNegativeStock ? 99999999999 : this
								.getSelectedCommodityTypeMaxStock(params.index);

							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': maxValue
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.documentItem.outStoreDetailList[params.index]
											.quantity = e;
									}
								}
							})]
						}
					},
					{
						title: '采购价格',
						key: 'price',
						width: 200,
						render: (h, params) => {
							let unitData = this.getUnitData(params.row.commodity, params.row.unit);
							let price = params.row.price;
							if (unitData) {
								price = formatNum(price / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 400,
					}
				],
				userList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				scanCodeId: '',
				enterDownTime: '',
				enterUpTime: ''
			}
		},

		methods: {
			emptyForm() {
				this.documentItem.id = 0;
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.outStoreDetailList = [];
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.checkState = 1;
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			getSelectedCommodityTypeMaxStock(index) {
				let detail = this.documentItem.outStoreDetailList[index];
				if (!detail.commodity.commodityInventorys) return 0;

				// 如果允许负库存，直接返回大数
				if (detail.commodity.negativeStock) {
					return 99999999999;
				}

				let stock = 0;
				let commodityInventorys = detail.commodity.commodityInventorys;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == detail.format) {
						stock += commodityInventorys[i].stock;
					}
				}

				// 减去已选数量
				let details = this.documentItem.outStoreDetailList;
				for (let i = 0; i < details.length; i++) {
					if (i != index) {
						if (detail.format == details[i].format) {
							for (let j = 0; j < details[i].commodity.extraUnits.length; j++) {
								if (details[i].unit == details[i].commodity
									.extraUnits[j].unit) {
									stock -= details[i].quantity / details[i]
										.commodity.extraUnits[j].conversionRate;
								}
							}
						}
					}
				}

				let unitData = detail.commodity.extraUnits.find(m => m.unit == detail.unit);

				if (unitData) {
					stock = unitData.conversionRate * stock;
				}
				return formatNum(stock);
			},
			onInputVal(val) {
				this.$refs.selectCommodityModal.searchItems.name = val;
				this.$refs.selectCommodityModal.openSelectCommodityModal();
			},
			formatBatchCodeSelectData(index, unit) {
				let data = this.documentItem.outStoreDetailList[index];
				let unitData = this.getUnitData(data, unit);
				if (data && unitData) {
					let list = []
					if (data.commodity.commodityInventorys) {
						const allowNegativeStock = data.commodity.negativeStock;
						let array = data.commodity.commodityInventorys.filter(m => {
							if (allowNegativeStock) {
								return m.commodityPriceType == data.format;
							} else {
								return m.stock > 0 && m.commodityPriceType == data.format;
							}
						});
						array = array.sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));
						for (let i = 0; i < array.length; i++) {
							list.push({
								value: array[i].batchCode,
								text: `${array[i].batchCode}(${formatNum(array[i].stock * unitData.conversionRate)}${unit})`
							})
						}
					}
					return list;
				}
			},
			getUnitData(item, unit) {
				if (item.commodity.extraUnits) {
					let unitData = item.commodity.extraUnits.find(m => m.unit == unit);
					if (unitData) {
						return unitData;
					}
				}
				return null;
			},
			getLatestBatchCode(item1, item2) {
				if (item1.commodity.enableBatch != true) {
					return null;
				}
				if (!item1.commodity.commodityInventorys || item1.commodity.commodityInventorys.length <= 0) {
					return null;
				}

				const allowNegativeStock = item1.commodity.negativeStock;
				let codes = [];
				let totalStock = 0;
				let unitData = this.getUnitData(item1, item2.unit);
				if (unitData) {
					let latestCode = item1.commodity.commodityInventorys.filter(m => {
						if (allowNegativeStock) {
							return m.commodityPriceType == item2.priceType;
						} else {
							return m.stock > 0 && m.commodityPriceType == item2.priceType;
						}
					}).sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));

					for (let i = 0; i < latestCode.length; i++) {
						totalStock += formatNum(latestCode[i].stock * unitData.conversionRate);
						codes.push(latestCode[i].batchCode);
						if (!allowNegativeStock && totalStock > item2.quantity) {
							break;
						}
					}
				}
				return codes;
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.outStoreDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.outStoreDetailList[index]
						.format) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.outStoreDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.outStoreDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				return formatNum(stock);
			},
			getCommodityTypePrice(data) {
				const currentUnit = data.commodity.extraUnits.find(m => m.unit == data.unit);
				const priceTypeItems = data.format.split(',');
				let currentPriceType = null;
				if (priceTypeItems.length === 2) {
					currentPriceType = this.findPriceType(data.commodity, priceTypeItems);
				}
				if (currentUnit && currentPriceType) {
					let price = currentPriceType.intoPrice;
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;
				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);
				if (!targetGroup) return null;
				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}
				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				}
				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}
				if (this.documentItem.outStoreDetailList.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}
				let details = this.documentItem.outStoreDetailList;
				for (let i = 0; i < details.length; i++) {
					if (details[i].commodity.enableBatch == true && (!details[i].batchCode || details[i].batchCode
							.length <= 0)) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: `“${details[i].format}”规格未选择批次号`
						});
						return false
					}
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/OutStoreList/EditOutStoreList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					var log = {
						FlowId: response.data,
						Title: '其它出库单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此其它出库单' : '创建了此其它出库单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				let path = '';
				if (self.documentItem.id) {
					path = '/api/OutStoreList/EditOutStoreList';
				} else {
					path = '/api/OutStoreList/AddOutStoreList';
				}
				request.post(path, self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					var log = {
						FlowId: self.documentItem.id ? response.data : response.data.id,
						Title: '其它出库单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此其它出库单' : '创建了此其它出库单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					if (!self.documentItem.id) {
						self.documentItem = response.data;
					} else {
						self.documentItem.id = response.data;
					}
					self.checkOutStoreList(self.documentItem, '其它出库单审核后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/OutStoreList/GetNextCode', {
					params: {
						prefix: 'CKD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/OutStoreList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "其它出库单回滚失败：" + response.errorMsg
								});
								return;
							}
							var log = [];
							for (var i = 0; i < ids.length; i++) {
								log.push({
									FlowId: ids[i],
									Title: '其它出库单日志',
									OperationContent: '回滚了此其它出库单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getOutStoreList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkOutStoreList(data, func) {
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/OutStoreList/CheckOutStoreList', [{
							id: data.id,
							state: 2
						}]).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							log.push({
								FlowId: data.id,
								Title: '其它出库单日志',
								OperationContent: '审核了此其它出库单',
								Operator: parseInt(localStorage.getItem("userId")),
								State: 1,
								Creator: parseInt(localStorage.getItem("userId"))
							});
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '审核成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			initUserToSelect() {
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['OutStoreList.Add', 'OutStoreList.Edit', 'OutStoreList.Delete',
						'OutStoreList.Audit', 'OutStoreList.BatchAudit', 'OutStoreList.Print',
						'OutStoreList.Rollback', 'OutStoreList.Export', 'OutStoreList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'OutStoreList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'OutStoreList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'OutStoreList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'OutStoreList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'OutStoreList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'OutStoreList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'OutStoreList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'OutStoreList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'OutStoreList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			getUnitData(detail, unitName) {
				if (detail.commodity.extraUnits) {
					let unit = detail.commodity.extraUnits.find(m => m.unit == unitName);
					if (unit) {
						return unit;
					}
				}
				return null;
			},
			getCurrentRetailPrice(data) {
				let items = data.format.split(',');
				if (items.length <= 0) {
					return 0;
				}
				let priceTypeGroup = data.commodity
					.commodityPriceTypeGroups.find(m => m.groupName == items[0]);
				if (!priceTypeGroup || priceTypeGroup.commodityPriceTypes.length <= 0) {
					return 0;
				}
				let priceType = priceTypeGroup.commodityPriceTypes.find(m => m.priceType == items[1]);
				if (!priceType) {
					return 0;
				}
				let unitData = this.getUnitData(data, data.unit);
				if (!unitData) {
					return 0;
				}
				return formatNum(priceType.retailPrice / unitData.conversionRate);
			},
			printList() {
				const printData = this.formatPrintData([this.documentItem])
				this.printWithTemplate(printData, 'outStoreList')
			},
			formatPrintData(rawData) {
				if (!Array.isArray(rawData)) {
					console.error('formatPrintData: rawData 不是数组', rawData);
					return [];
				}
				const addSerialNo = (arr) => arr.map((item, idx) => ({
					...item,
					serialNo: idx + 1
				}));
				const safeNumber = (value) => {
					const num = Number(value);
					return isNaN(num) ? 0 : num;
				};
				const calcTotals = (arr, fields) => {
					if (!Array.isArray(arr) || arr.length === 0) {
						const emptyTotals = {};
						fields.forEach(f => {
							emptyTotals[f] = 0;
						});
						return emptyTotals;
					}
					const totals = {};
					fields.forEach(f => {
						totals[f] = 0;
					});
					arr.forEach(item => {
						fields.forEach(f => {
							totals[f] += safeNumber(item[f]);
						});
					});
					return totals;
				};
				const formatDate = (dateStr) => {
					if (!dateStr) return '';
					if (dateStr instanceof Date) {
						const year = dateStr.getFullYear();
						const month = String(dateStr.getMonth() + 1).padStart(2, '0');
						const day = String(dateStr.getDate()).padStart(2, '0');
						return `${year}-${month}-${day}`;
					}
					if (typeof dateStr === 'string') {
						return dateStr.split(' ')[0];
					}
					return '';
				};
				const getCommodityPrice = (item) => {
					if (item.commodity && item.commodity.retailPrice) {
						return safeNumber(item.commodity.retailPrice);
					}
					return 0;
				};
				const formatSingle = (record) => {
					if (!record) return {};
					let commodityRaw = (record.outStoreDetailList || []).map(item => ({
						name: item.name || '',
						format: item.format || '',
						unit: item.unit || '',
						quantity: safeNumber(item.quantity),
						price: getCommodityPrice(item),
						batchCode: item.batchCode || '',
						note: item.note || ''
					}));
					let commodityStockDetail = addSerialNo(commodityRaw);
					if (commodityRaw.length > 0) {
						const totals = calcTotals(commodityRaw, ['quantity']);
						const totalAmount = commodityRaw.reduce((sum, item) => sum + (item.quantity * item.price), 0);
						commodityStockDetail.push({
							serialNo: '',
							name: '',
							format: '',
							unit: '合计',
							quantity: totals.quantity,
							price: '',
							batchCode: '',
							note: '',
							totalAmount: totalAmount,
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}
					return {
						code: record.code || '',
						userName: record.userName || '',
						businessDate: formatDate(record.businessDate),
						note: record.note || '',
						commodityStockDetail: commodityStockDetail
					};
				};
				return rawData.map(record => formatSingle(record));
			},
			getOutStoreList(outStoreListId) {
				let self = this;
				request.get('/api/OutStoreList/GetOutStoreList', {
					params: {
						id: outStoreListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initOutStoreList(response.data);
				}).catch(function(error) {})
			},
			initOutStoreList(data) {
				this.documentItem = data;
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
			}
		},
		watch: {
			'$route.query.outStoreListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getOutStoreList(param);
					} else {
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}

	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
</style>